<div class="files-list d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-column flex-grow-1">
    <div class="d-flex flex-row justify-content-between">
      <span>{{ file().name }}</span>
      <span>{{ uploadProgressSize() | fileSize }}/{{ file().size | fileSize }}</span>
    </div>
    <mat-progress-bar mode="determinate" color="primary" [value]="uploadProgressPercentage()"></mat-progress-bar>
    @if (hasError()) {
      <span class="upload-error-message">{{ errorMessage() }}</span>
    }
  </div>
  <mat-form-field class="document-date-field ms-3">
    <mat-label>Document Date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="documentDate">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <xui-tag-search
    class="w-40 ms-3"
    [searchObservable]="searchTags"
    [(tags)]="fileTags"
    (tagsChange)="onTagsChange($event)">
  </xui-tag-search>
  <!-- A flagged file (no extension / too large) must stay removable so the user can drop just
       the bad file instead of clearing the whole selection; only block deletion while the item
       is actively uploading or already complete. -->
  <button
    mat-icon-button
    (click)="deleteAttachment()"
    [class.disabled]="uploading() || processing() || complete()">
    <mat-icon>delete</mat-icon>
  </button>
</div>
